import React, { useEffect, useState } from "react";
import {
    Modal,
    Button,
    Icon,
    Form,
    Label,
    Message,
} from "semantic-ui-react";
import moment from "moment";

const ModalAtencionST = ({
    open,
    equipo,
    mantencion,
    diasRestantes,
    preventivaDisponible,
    guardando,
    onClose,
    onConfirmar,
}) => {

    /* =========================================================
       ESTADOS
    ========================================================= */

    const [tipoAtencion, setTipoAtencion] = useState("");
    const [observacion, setObservacion] = useState("");
    const [error, setError] = useState("");

    /* =========================================================
       INICIALIZAR MODAL
    ========================================================= */

    useEffect(() => {

        if (!open) return;

        setObservacion("");
        setError("");

        /*
         * Si la preventiva NO está disponible,
         * la atención pasa automáticamente a CORRECTIVA.
         */
        if (!preventivaDisponible) {
            setTipoAtencion("CORRECTIVA");
        } else {
            setTipoAtencion("");
        }

    }, [
        open,
        preventivaDisponible,
        equipo?.id,
    ]);

    /* =========================================================
       FECHA MANTENCIÓN
    ========================================================= */

    const obtenerFechaMantencion = () => {

        if (!mantencion?.fecha_termino) {
            return "";
        }

        let fecha = mantencion.fecha_termino;

        if (typeof fecha?.toDate === "function") {
            fecha = fecha.toDate();
        }

        const fechaMoment = moment(fecha);

        if (!fechaMoment.isValid()) {
            return "";
        }

        return fechaMoment.format("DD/MM/YYYY");
    };

    const fechaMantencion = obtenerFechaMantencion();

    /* =========================================================
       TEXTO DÍAS
    ========================================================= */

    const obtenerTextoDias = () => {

        if (
            diasRestantes === null ||
            diasRestantes === undefined
        ) {
            return "";
        }

        if (diasRestantes < 0) {

            const diasVencidos = Math.abs(
                diasRestantes
            );

            return diasVencidos === 1
                ? "Vencida hace 1 día"
                : `Vencida hace ${diasVencidos} días`;
        }

        if (diasRestantes === 0) {
            return "Vence hoy";
        }

        if (diasRestantes === 1) {
            return "Falta 1 día";
        }

        return `Faltan ${diasRestantes} días`;
    };

    const textoDias = obtenerTextoDias();

    /* =========================================================
       SELECCIONAR ATENCIÓN
    ========================================================= */

    const seleccionarAtencion = (
        tipoSeleccionado
    ) => {

        setTipoAtencion(
            tipoSeleccionado
        );

        setError("");

        if (
            tipoSeleccionado ===
            "PREVENTIVA"
        ) {
            setObservacion("");
        }
    };

    /* =========================================================
       CONFIRMAR
    ========================================================= */

    const handleConfirmar = () => {

        if (!tipoAtencion) {

            setError(
                "Debe seleccionar el tipo de atención."
            );

            return;
        }

        if (
            tipoAtencion === "CORRECTIVA" &&
            !observacion.trim()
        ) {

            setError(
                "Debe ingresar la falla o síntoma reportado."
            );

            return;
        }

        setError("");

        onConfirmar({
            tipoAtencion,

            observacion:
                tipoAtencion === "CORRECTIVA"
                    ? observacion.trim()
                    : "",

            idMantencion:
                tipoAtencion === "PREVENTIVA"
                    ? mantencion?.id || ""
                    : "",
        });
    };

    /* =========================================================
       RENDER
    ========================================================= */

    return (
        <Modal
            open={open}
            onClose={onClose}
            closeOnDimmerClick={!guardando}
            closeOnEscape={!guardando}
            size="small"
            style={{
                width: "calc(100% - 32px)",
                maxWidth: 650,

                /*
                 * Dejamos margen vertical suficiente incluso
                 * en notebook con la barra superior de LogisticMed.
                 */
                maxHeight:
                    "calc(100vh - 130px)",

                borderRadius: 10,
                overflow: "hidden",

                display: "flex",
                flexDirection: "column",

                boxShadow:
                    "0 18px 48px rgba(9,30,66,0.28)",
            }}
        >

            {/* =================================================
                HEADER
            ================================================= */}

            <Modal.Header
                style={{
                    flexShrink: 0,

                    padding:
                        "13px 18px",

                    background:
                        "#ffffff",

                    borderBottom:
                        "1px solid #e5e9ef",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 11,
                    }}
                >

                    <div
                        style={{
                            width: 36,
                            height: 36,
                            minWidth: 36,

                            borderRadius: 7,

                            background:
                                "#e8f7f8",

                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <Icon
                            name="wrench"
                            style={{
                                margin: 0,
                                color: "#0d9da5",
                                fontSize: 16,
                            }}
                        />
                    </div>

                    <div
                        style={{
                            minWidth: 0,
                        }}
                    >
                        <div
                            style={{
                                fontSize: 16,
                                fontWeight: 700,
                                color: "#253858",
                                lineHeight: 1.25,
                            }}
                        >
                            Tipo de atención
                        </div>

                        <div
                            style={{
                                fontSize: 11.5,
                                fontWeight: 400,
                                color: "#6b778c",
                                marginTop: 2,
                            }}
                        >
                            Seleccione el motivo de ingreso
                            a Servicio Técnico
                        </div>
                    </div>

                </div>
            </Modal.Header>

            {/* =================================================
                CONTENIDO
            ================================================= */}

            <Modal.Content
                style={{
                    flex: 1,
                    minHeight: 0,

                    overflowY: "auto",

                    padding:
                        "14px 18px",

                    background:
                        "#ffffff",
                }}
            >

                {/* =================================================
                    EQUIPO
                ================================================= */}

                <div
                    style={{
                        border:
                            "1px solid #dfe3e8",

                        borderRadius: 7,

                        background:
                            "#f8fafc",

                        padding:
                            "10px 13px",

                        marginBottom: 11,
                    }}
                >

                    <div
                        style={{
                            display: "flex",
                            justifyContent:
                                "space-between",
                            alignItems:
                                "center",

                            gap: 12,

                            flexWrap:
                                "wrap",
                        }}
                    >

                        <div
                            style={{
                                minWidth: 0,
                                flex: 1,
                            }}
                        >

                            <div
                                style={{
                                    fontSize: 10.5,
                                    fontWeight: 700,
                                    color: "#6b778c",
                                    marginBottom: 3,
                                }}
                            >
                                EQUIPO SELECCIONADO
                            </div>

                            <div
                                style={{
                                    fontSize: 15,
                                    lineHeight: 1.25,
                                    fontWeight: 700,
                                    color: "#253858",
                                }}
                            >
                                {equipo?.tipo ||
                                    "Equipo"}
                            </div>

                            <div
                                style={{
                                    marginTop: 3,
                                    fontSize: 11.5,
                                    color: "#6b778c",
                                    lineHeight: 1.3,
                                }}
                            >
                                {[
                                    equipo?.marca,
                                    equipo?.modelo,
                                    equipo?.familia,
                                ]
                                    .filter(Boolean)
                                    .join(" · ")}
                            </div>

                        </div>

                        <Label
                            size="small"
                            style={{
                                margin: 0,

                                background:
                                    "#ffffff",

                                color:
                                    "#344563",

                                border:
                                    "1px solid #dfe1e6",
                            }}
                        >
                            <Icon name="barcode" />

                            {equipo?.serie ||
                                "Sin serie"}
                        </Label>

                    </div>

                </div>

                {/* =================================================
                    INFORMACIÓN MANTENCIÓN
                ================================================= */}

                {mantencion ? (

                    <div
                        style={{
                            border:
                                preventivaDisponible
                                    ? "1px solid #b7dfc5"
                                    : "1px solid #f2c98a",

                            borderRadius: 7,

                            background:
                                preventivaDisponible
                                    ? "#f4fbf6"
                                    : "#fffaf2",

                            padding:
                                "10px 13px",

                            marginBottom: 12,
                        }}
                    >

                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent:
                                    "space-between",

                                gap: 10,

                                flexWrap: "wrap",
                            }}
                        >

                            <div>

                                <div
                                    style={{
                                        fontSize: 11.5,
                                        fontWeight: 700,
                                        color: "#344563",
                                    }}
                                >
                                    Próxima mantención preventiva
                                </div>

                                <div
                                    style={{
                                        marginTop: 2,
                                        fontSize: 13,
                                        color: "#5e6c84",
                                    }}
                                >
                                    {fechaMantencion ||
                                        "Sin fecha programada"}
                                </div>

                            </div>

                            {textoDias && (

                                <Label
                                    size="small"
                                    color={
                                        preventivaDisponible
                                            ? "green"
                                            : "orange"
                                    }
                                    style={{
                                        margin: 0,
                                    }}
                                >
                                    {textoDias}
                                </Label>

                            )}

                        </div>

                        {!preventivaDisponible && (

                            <div
                                style={{
                                    marginTop: 7,

                                    display: "flex",
                                    gap: 6,
                                    alignItems:
                                        "flex-start",

                                    fontSize: 11.5,
                                    lineHeight: 1.35,

                                    color:
                                        "#8a6116",
                                }}
                            >

                                <Icon
                                    name="info circle"
                                    style={{
                                        marginTop: 1,
                                    }}
                                />

                                <span>
                                    La mantención aún no está
                                    dentro de la ventana de 7
                                    días. Solo puede registrar
                                    una atención correctiva.
                                </span>

                            </div>

                        )}

                    </div>

                ) : (

                    <Message
                        warning
                        size="tiny"
                        icon
                        style={{
                            marginTop: 0,
                            marginBottom: 12,
                            padding:
                                "10px 12px",
                        }}
                    >
                        <Icon name="calendar times outline" />

                        <Message.Content>

                            <Message.Header>
                                Sin mantención programada
                            </Message.Header>

                            No existe una preventiva
                            programada para este equipo.
                            Solo puede registrar una
                            atención correctiva.

                        </Message.Content>

                    </Message>

                )}

                {/* =================================================
                    TIPO DE ATENCIÓN
                ================================================= */}

                <div
                    style={{
                        marginBottom:
                            tipoAtencion ===
                            "CORRECTIVA"
                                ? 11
                                : 0,
                    }}
                >

                    <div
                        style={{
                            fontSize: 12,
                            fontWeight: 700,
                            color: "#344563",
                            marginBottom: 7,
                        }}
                    >
                        Tipo de atención
                    </div>

                    {preventivaDisponible ? (

                        <div
                            style={{
                                display: "grid",

                                gridTemplateColumns:
                                    "repeat(2, minmax(0, 1fr))",

                                gap: 9,
                            }}
                        >

                            {/* =====================================
                                PREVENTIVA
                            ===================================== */}

                            <button
                                type="button"
                                onClick={() =>
                                    seleccionarAtencion(
                                        "PREVENTIVA"
                                    )
                                }
                                disabled={guardando}
                                style={{
                                    appearance: "none",

                                    width: "100%",

                                    border:
                                        tipoAtencion ===
                                        "PREVENTIVA"
                                            ? "2px solid #0d9da5"
                                            : "1px solid #dfe1e6",

                                    background:
                                        tipoAtencion ===
                                        "PREVENTIVA"
                                            ? "#f0fbfc"
                                            : "#ffffff",

                                    borderRadius: 7,

                                    padding:
                                        "10px 12px",

                                    cursor:
                                        guardando
                                            ? "default"
                                            : "pointer",

                                    textAlign:
                                        "left",

                                    fontFamily:
                                        "inherit",
                                }}
                            >

                                <div
                                    style={{
                                        display: "flex",
                                        alignItems:
                                            "center",
                                        gap: 9,
                                    }}
                                >

                                    <Icon
                                        name="calendar check outline"
                                        style={{
                                            color:
                                                "#0d9da5",
                                            fontSize: 17,
                                            margin: 0,
                                        }}
                                    />

                                    <div>

                                        <div
                                            style={{
                                                color:
                                                    "#253858",
                                                fontSize: 13,
                                                fontWeight: 700,
                                            }}
                                        >
                                            Preventiva
                                        </div>

                                        <div
                                            style={{
                                                fontSize: 10.5,
                                                color:
                                                    "#6b778c",
                                                marginTop: 1,
                                            }}
                                        >
                                            Mantención programada
                                        </div>

                                    </div>

                                </div>

                            </button>

                            {/* =====================================
                                CORRECTIVA
                            ===================================== */}

                            <button
                                type="button"
                                onClick={() =>
                                    seleccionarAtencion(
                                        "CORRECTIVA"
                                    )
                                }
                                disabled={guardando}
                                style={{
                                    appearance: "none",

                                    width: "100%",

                                    border:
                                        tipoAtencion ===
                                        "CORRECTIVA"
                                            ? "2px solid #f2711c"
                                            : "1px solid #dfe1e6",

                                    background:
                                        tipoAtencion ===
                                        "CORRECTIVA"
                                            ? "#fff7f2"
                                            : "#ffffff",

                                    borderRadius: 7,

                                    padding:
                                        "10px 12px",

                                    cursor:
                                        guardando
                                            ? "default"
                                            : "pointer",

                                    textAlign:
                                        "left",

                                    fontFamily:
                                        "inherit",
                                }}
                            >

                                <div
                                    style={{
                                        display: "flex",
                                        alignItems:
                                            "center",
                                        gap: 9,
                                    }}
                                >

                                    <Icon
                                        name="wrench"
                                        style={{
                                            color:
                                                "#f2711c",
                                            fontSize: 17,
                                            margin: 0,
                                        }}
                                    />

                                    <div>

                                        <div
                                            style={{
                                                color:
                                                    "#253858",
                                                fontSize: 13,
                                                fontWeight: 700,
                                            }}
                                        >
                                            Correctiva / falla
                                        </div>

                                        <div
                                            style={{
                                                fontSize: 10.5,
                                                color:
                                                    "#6b778c",
                                                marginTop: 1,
                                            }}
                                        >
                                            Equipo presenta una falla
                                        </div>

                                    </div>

                                </div>

                            </button>

                        </div>

                    ) : (

                        /*
                         * Cuando preventiva no está disponible no
                         * necesitamos mostrar una tarjeta enorme.
                         * Solo mostramos la atención activa.
                         */

                        <div
                            style={{
                                display: "flex",
                                alignItems:
                                    "center",
                                gap: 10,

                                border:
                                    "1px solid #f2711c",

                                borderLeft:
                                    "4px solid #f2711c",

                                borderRadius: 6,

                                background:
                                    "#fff8f4",

                                padding:
                                    "9px 12px",
                            }}
                        >

                            <Icon
                                name="wrench"
                                style={{
                                    color:
                                        "#f2711c",
                                    fontSize: 17,
                                    margin: 0,
                                }}
                            />

                            <div>

                                <div
                                    style={{
                                        color:
                                            "#253858",
                                        fontSize: 13,
                                        fontWeight: 700,
                                    }}
                                >
                                    Correctiva / falla
                                </div>

                                <div
                                    style={{
                                        fontSize: 10.5,
                                        color:
                                            "#6b778c",
                                        marginTop: 1,
                                    }}
                                >
                                    Única atención disponible
                                    actualmente
                                </div>

                            </div>

                        </div>

                    )}

                </div>

                {/* =================================================
                    FALLA / SÍNTOMA
                ================================================= */}

                {tipoAtencion ===
                    "CORRECTIVA" && (

                    <Form>

                        <Form.Field
                            required
                            style={{
                                marginBottom: 5,
                            }}
                        >

                            <label
                                style={{
                                    fontSize: 12,
                                    color:
                                        "#344563",
                                }}
                            >
                                Falla o síntoma reportado
                            </label>

                            <textarea
                                rows={2}
                                value={observacion}
                                disabled={guardando}
                                maxLength={500}
                                placeholder="Ej: Equipo se apaga después de algunos minutos..."
                                onChange={(e) => {

                                    setObservacion(
                                        e.target.value
                                    );

                                    if (error) {
                                        setError("");
                                    }
                                }}
                                style={{
                                    minHeight: 64,
                                    maxHeight: 90,
                                    resize: "vertical",
                                }}
                            />

                        </Form.Field>

                        <div
                            style={{
                                display: "flex",
                                justifyContent:
                                    "space-between",
                                gap: 12,

                                fontSize: 10.5,
                                lineHeight: 1.35,

                                color:
                                    "#6b778c",
                            }}
                        >

                            <span>
                                Describa lo observado. La
                                causa técnica será determinada
                                por Servicio Técnico.
                            </span>

                            <span
                                style={{
                                    whiteSpace:
                                        "nowrap",
                                }}
                            >
                                {observacion.length}/500
                            </span>

                        </div>

                    </Form>

                )}

                {/* =================================================
                    ERROR
                ================================================= */}

                {error && (

                    <Message
                        negative
                        size="tiny"
                        style={{
                            marginTop: 10,
                            marginBottom: 0,
                            padding:
                                "9px 11px",
                        }}
                    >

                        <Icon name="warning sign" />

                        {error}

                    </Message>

                )}

            </Modal.Content>

            {/* =================================================
                ACCIONES
            ================================================= */}

            <Modal.Actions
                style={{
                    flexShrink: 0,

                    padding:
                        "9px 18px",

                    background:
                        "#f8fafc",

                    borderTop:
                        "1px solid #e5e9ef",

                    display: "flex",
                    justifyContent:
                        "flex-end",

                    gap: 8,
                }}
            >

                <Button
                    type="button"
                    basic
                    size="small"
                    disabled={guardando}
                    onClick={onClose}
                >
                    Cancelar
                </Button>

                <Button
                    type="button"
                    size="small"
                    loading={guardando}
                    disabled={
                        guardando ||
                        !tipoAtencion
                    }
                    onClick={
                        handleConfirmar
                    }
                    style={{
                        minWidth: 120,

                        background:
                            "#0d9da5",

                        color:
                            "#ffffff",
                    }}
                >
                    <Icon name="check" />
                    Confirmar
                </Button>

            </Modal.Actions>

        </Modal>
    );
};

export default ModalAtencionST;